// extracted by mini-css-extract-plugin
module.exports = {"projectName":"_e667f7b1","projectLocation":"_312e040b"};